var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { authPin, exitKiosk } from '../../../http/inspections';
import { exitKioskMode } from '../../../utility/kiosk';
import { navigate, withToken } from '../../../utility/general';
import CModal from '../../components/modal';
import CModalConfirm from '../../components/modal.confirm';
import CInput from '../../components/input';
import Button from '../../components/button';
import Layout from './layout';
export default (props) => {
    var _a;
    const [token, setToken] = withToken();
    const shopName = ((_a = token === null || token === void 0 ? void 0 : token.merchant) === null || _a === void 0 ? void 0 : _a.business_name) || 'Inspection Mode';
    const [pin, setPin] = React.useState('');
    const [error, setError] = React.useState(null);
    const [submitting, setSubmitting] = React.useState(false);
    const [exitModal, setExitModal] = React.useState(null);
    const [exitSubmitting, setExitSubmitting] = React.useState(false);
    const [logoutModal, setLogoutModal] = React.useState(false);
    const loggedOutRef = React.useRef(false); // TODO: someday remove or factor out
    const submitPin = (value) => __awaiter(void 0, void 0, void 0, function* () {
        if (submitting) {
            return;
        }
        setSubmitting(true);
        yield authPin(value, {
            'success': (result) => {
                if (loggedOutRef.current) {
                    return;
                }
                setError(null);
                setSubmitting(false);
                props.onAuthenticated(result.performer_id, result.display_name);
                navigate('#/inspection-mode/my-jobs');
            },
            'error': (res) => __awaiter(void 0, void 0, void 0, function* () {
                if (loggedOutRef.current) {
                    return;
                }
                const body = yield res.json().catch(() => ({}));
                setError(body.message || 'Invalid PIN');
                setPin('');
                setSubmitting(false);
            }),
        });
    });
    React.useEffect(() => {
        if (pin.length === 4) {
            submitPin(pin);
        }
    }, [pin]);
    const pressKey = (digit) => {
        setError(null);
        if (pin.length < 4 && !submitting) {
            setPin(pin + digit);
        }
    };
    const clear = () => { setError(null); setPin(''); };
    const backspace = () => { setError(null); setPin(pin.slice(0, -1)); };
    const confirmLogout = () => {
        loggedOutRef.current = true;
        exitKioskMode();
        setToken(null);
        navigate('#/login');
    };
    const submitExitKiosk = () => {
        if (exitSubmitting) {
            return;
        }
        if (!(exitModal === null || exitModal === void 0 ? void 0 : exitModal.password)) {
            setExitModal((x) => x ? Object.assign(Object.assign({}, x), { 'error': 'Password is required' }) : x);
            return;
        }
        setExitSubmitting(true);
        tryExitKiosk(() => setExitSubmitting(false));
    };
    const tryExitKiosk = (finish) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (!exitModal) {
                return;
            }
            yield exitKiosk(exitModal.password, {
                'success': () => {
                    exitKioskMode();
                    setExitModal(null);
                    navigate('#/');
                },
                'error': (res) => __awaiter(void 0, void 0, void 0, function* () {
                    const body = yield res.json().catch(() => ({}));
                    setExitModal((x) => x ? Object.assign(Object.assign({}, x), { 'error': body.message || 'Invalid password' }) : x);
                }),
            });
        }
        finally {
            finish();
        }
    });
    const KeyButton = ({ children, onClick }) => _jsx("button", { type: "button", className: "btn btn-outline-primary mx-1 my-1", style: { 'width': '5rem', 'height': '5rem', 'fontSize': '1.75rem' }, onClick: onClick, children: children });
    return _jsxs(_Fragment, { children: [_jsx(Layout, { title: shopName, children: _jsxs("div", { className: "d-flex flex-column align-items-center justify-content-center", style: { 'minHeight': '70vh' }, children: [_jsx("h3", { className: "mb-3", children: "Enter Your PIN" }), _jsx("div", { className: "font-monospace mb-4", style: { 'fontSize': '2.5rem', 'letterSpacing': 0, 'minHeight': '3rem' }, children: [0, 1, 2, 3].map(i => pin[i] ? '*' : '_').join(' ') }), !!error && _jsx("div", { className: "alert alert-danger py-2 px-3 mb-3", children: error }), _jsx("div", { children: [['1', '2', '3'], ['4', '5', '6'], ['7', '8', '9'], ['C', '0', 'Del']].map((row, ri) => _jsx("div", { className: "d-flex justify-content-center", children: row.map((d) => _jsx(KeyButton, { onClick: () => {
                                        switch (d) {
                                            case 'C': return clear();
                                            case 'Del': return backspace();
                                            default: return pressKey(d);
                                        }
                                    }, children: d }, d)) }, ri)) }), _jsx("button", { type: "button", className: "btn btn-link text-muted mt-3 small", onClick: () => setExitModal({ 'password': '', 'error': null }), children: "Exit Kiosk Mode" })] }) }), _jsx(CModal, { visible: !!exitModal, title: "Exit Inspection Mode", onClose: () => setExitModal(null), sm: true, nofooter: true, children: !!exitModal && _jsxs(_Fragment, { children: [_jsx("p", { className: "text-muted small", children: "Enter your account password to return to the main app." }), _jsx(CInput, { type: "password", value: exitModal.password, onChange: (x) => setExitModal(Object.assign(Object.assign({}, exitModal), { 'password': x })), required: true, error: exitModal.error || undefined, children: "Password" }), _jsx("div", { className: "text-end", children: _jsx(Button, { submit: true, color: "primary", disabled: exitSubmitting, onClick: submitExitKiosk, children: "Exit Kiosk" }) }), _jsx("hr", {}), _jsx("p", { className: "small", children: "If you forgot your password please log out and use the forgot password option." }), _jsx("div", { className: "text-center", children: _jsx(Button, { color: "danger", onClick: () => { setExitModal(null); setLogoutModal(true); }, children: "Log Out" }) }), _jsx("p", { className: "text-muted small text-center mt-2 mb-0", children: "You will need the admin password to log in again." })] }) }), _jsx(CModalConfirm, { title: "Log Out", action: "Log Out", visible: logoutModal, onClose: () => setLogoutModal(false), onSubmit: confirmLogout, children: _jsx("p", { children: "Are you sure you want to log out? You will need the admin password to log in again." }) })] });
};
